import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/fr";

export default {
  locale: "fr",
  name: "Conditions",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "ticker",
        displayName: "Code",
      },
      {
        fieldName: "conditionType",
        displayName: "Type de condition",
        optionDisplay: {
          ENGINE: { label: "Moteur" },
          STORE: { label: "Boutique" },
          FLIGHT_HOTEL: { label: "Vol + Hôtel" },
        },
      },
      {
        fieldName: "name",
        displayName: "Nom",
      },
      {
        fieldName: "earlyCharge",
        displayName: "%acompte",
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Facturer la première nuit",
      },
      {
        fieldName: "policies",
        displayName: "Politiques d'annulation",
      },
      {
        fieldName: "payments",
        displayName: "Méthodes de paiement",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Montant minimum",
      },
      {
        fieldName: "motorsList",
        displayName: "Moteurs",
      },
      {
        fieldName: "uso",
        displayName: "Utilisation",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "ticker",
        displayName: "Code",
      },
      {
        fieldName: "conditionType",
        displayName: "Condition de magasin",
      },
      {
        fieldName: "isFlightHotelCondition",
        displayName: "Condition Vol + Hôtel",
      },
      {
        fieldName: "flightHotelPaymentType",
        displayName: "Prépaiement (Maarlab)",
        optionDisplay: {
          FLIGHT_ONLY: { label: "Vol uniquement" },
          ALL_NOW: { label: "Tout maintenant" },
          // Temporarily disabled: FLIGHT_NOW_HOTEL_LATER is not offered for now.
          // FLIGHT_NOW_HOTEL_LATER: { label: "Vol maintenant / hôtel plus tard" },
        },
      },
      {
        fieldName: "color",
        displayName: "Couleur",
      },
      {
        fieldName: "payments",
        displayName: "Méthodes de paiement",
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "earlyCharge",
        displayName: "% Acompte anticipé",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Montant minimum",
      },
      {
        fieldName: "policies",
        displayName: "Politiques d'annulation",
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Facturer la première nuit",
      },
      {
        fieldName: "name",
        displayName: "Nom",
      },
      {
        fieldName: "htmlCancellation",
        displayName: "Annulations / Prépaiement",
      },
      {
        fieldName: "htmlCheckIn",
        displayName: "Heure d'arrivée",
      },
      {
        fieldName: "htmlCheckOut",
        displayName: "Heure de départ",
      },
      {
        fieldName: "htmlChildren",
        displayName: "Enfants et lits supplémentaires",
      },
      {
        fieldName: "htmlPets",
        displayName: "Animaux de compagnie",
      },
      {
        fieldName: "htmlGroups",
        displayName: "Groupes",
      },
      {
        fieldName: "htmlExtraInfo",
        displayName: "Plus d'informations",
      },
      {
        fieldName: "selectedMotorsSection",
        displayName: "Sélection de propriétés",
      },
    ],
  },
};
